


import { setGetMailingStatisticsScrollerUsersOpenGameAction } from '../action';
import { getMailingStatisticsScrollerUsersOpenGame } from '../api/getMailingStatisticsScrollerUsersOpenGame';

export const setGetMailingStatisticsScrollerUsersOpenGame = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await getMailingStatisticsScrollerUsersOpenGame(params);

            dispatch(setGetMailingStatisticsScrollerUsersOpenGameAction(data))
        } catch (error) {
            alert('Ошибка')
            console.log(error)
        }
    }
}